export const WHEN_COMPLETE = 50;
